import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { useT } from "@/lib/i18n";

export const ConfirmDelete = ({ trigger, description, onConfirm, testid }) => {
  const { t } = useT();
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
      <AlertDialogContent data-testid={`${testid}-dialog`} className="bg-[#12141C] border-[#282D3D]">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading uppercase text-2xl">{t("confirm_title")}</AlertDialogTitle>
          <AlertDialogDescription>{description || t("confirm_generic")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancel-btn`}>{t("cancel")}</AlertDialogCancel>
          <AlertDialogAction data-testid={`${testid}-confirm-btn`} onClick={onConfirm} className="bg-[#FF3B30] hover:bg-[#e0332a]">
            {t("delete")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
